import { render } from "./store-dispatch-item-modal.vue?vue&type=template&id=43afe788"
import script from "./store-dispatch-item-modal.vue?vue&type=script&lang=js"
export * from "./store-dispatch-item-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__